// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__lKyHz","dark":"BaseLayout_dark__b9m26","light":"BaseLayout_light__4Ebyv"};